import Drawer from "../../../../drawer/Drawer";
import ManageFaq from "../ManageFaq";

const ManageFaqDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update FAQ" : "Add FAQ"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyclassName="p-0 max-h-[calc(100%-42px)]"
    >
      <ManageFaq getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageFaqDrawer;
